<template>
  <div>
    <el-tabs v-model="qdtab" style="margin-right: 40px;margin-left: 40px;">
      <el-tab-pane label="学员假条列表" name="readyyy">
        <el-row class="querypanel">
          <el-col :span="24">
            <el-form ref="form"  label-width="100px" label-position="left" >
              <el-form-item label="请假日期">
                <el-date-picker
                  v-model="pkdate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-form ref="form"  label-width="100px" label-position="left" >
              <el-form-item label="会员手机">
                <el-select v-model="ed_user_info" filterable clearable placeholder="请选择或输入会员手机"  height="120px">
                  <el-option
                    v-for="item in ed_user_list"
                    :key="item.phone.String"
                    :label="item.phone.String"
                    :value="item.phone.String">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button @click="query_pk">查找假条信息</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="data_pk"
            ref="multipleTable">
            <el-table-column
              prop="plandate.String"
              width="180px"
              label="请假日期">
            </el-table-column>
            <el-table-column
              prop="userphone.String"
              label="会员手机">
            </el-table-column>
            <el-table-column
              prop="weektime.String"
              label="时间段">
            </el-table-column>
            <el-table-column
              prop="cname.String"
              label="班级信息">
            </el-table-column>
            <el-table-column
              prop="teachername.String"
              label="讲师">
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="30px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="删除班级" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_pk(scope.$index, data_pk)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="学员手动请假" name="startyy">
        <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择会员">
                <el-input  v-model="ed_ma_member" placeholder="请选择预约的用户">
                  <el-button slot="append" icon="el-icon-search" @click="ev_sel_user"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="上课日期">
            <el-date-picker
              v-model="tscheduledate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="具体时间">
            <el-time-select
              placeholder="起始时间"
              v-model="ts_start"
              :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30'
                }">
            </el-time-select>
            <el-time-select
              placeholder="结束时间"
              v-model="ts_end"
              :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30',
                  minTime: startTime
                }">
            </el-time-select>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择讲师">
                <el-input  v-model="ed_ts_teacher" placeholder="请选择负责的讲师">
                  <el-button slot="append" icon="el-icon-search" @click="ev_sel_teacher"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择班级">
                <el-input  v-model="ed_ts_class" placeholder="请选择目前跟的班级（非必选）">
                  <el-button slot="append" icon="el-icon-search" @click="ev_sel_class"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择课程">
                <el-input  v-model="ed_ts_course" placeholder="请选择预约的课程">
                  <el-button slot="append" icon="el-icon-search" @click="ev_sel_course"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="slipline"></div>
        <el-button class="gibasebtn" style="margin-left: 20px" @click="save_vm">立即请假</el-button>
      </el-tab-pane>
      <el-tab-pane label="讲师假条列表" name="xyqj">
        <el-row class="querypanel">
          <el-col :span="24">
            <el-form ref="form"  label-width="100px" label-position="left" >
              <el-form-item label="请假日期">
                <el-date-picker
                  v-model="pkdate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-form ref="form"  label-width="100px" label-position="left" >
              <el-form-item label="讲师手机">
                <el-select v-model="ed_user_info" filterable clearable placeholder="请选择或输入会员手机"  height="120px">
                  <el-option
                    v-for="item in ed_user_list"
                    :key="item.phone.String"
                    :label="item.phone.String"
                    :value="item.phone.String">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button @click="query_jsjt">查找假条信息</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="data_jsjt"
            ref="multipleTable">
            <el-table-column
              prop="plandate.String"
              width="180px"
              label="请假日期">
            </el-table-column>
            <el-table-column
              prop="phone.String"
              label="讲师手机">
            </el-table-column>
            <el-table-column
              prop="weektime.String"
              label="时间段">
            </el-table-column>
            <el-table-column
              prop="context.String"
              label="请假内容">
            </el-table-column>
            <el-table-column
              prop="addtime.String"
              label="请假时间">
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="30px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="删除讲师假条" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_jsjt(scope.$index, data_jsjt)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="讲师手动请假" name="jsqj">
        <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择讲师">
                <el-input  v-model="ed_ts_teacher" placeholder="请选择负责的讲师">
                  <el-button slot="append" icon="el-icon-search" @click="ev_sel_teacher"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="上课日期">
            <el-date-picker
              v-model="tscheduledate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="具体时间">
            <el-time-select
              placeholder="起始时间"
              v-model="ts_start"
              :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30'
                }">
            </el-time-select>
            <el-time-select
              placeholder="结束时间"
              v-model="ts_end"
              :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30',
                  minTime: startTime
                }">
            </el-time-select>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="请假描述">
                <el-input  v-model="ed_ts_des" placeholder="请填写请假描述">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="slipline"></div>
        <el-button class="gibasebtn" style="margin-left: 20px" @click="save_jsqj">立即请假</el-button>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="讲师选择" :visible.sync="vis_sel_teacher">
      <el-table
        fit
        :data="data_teacher"
        highlight-current-row
        @current-change="sel_teacher_change"
        ref="multipleTable">
        <el-table-column
          prop="id.Int64"
          label="讲师编号">
        </el-table-column>
        <el-table-column
          prop="name.String"
          width="180px"
          label="讲师名">
        </el-table-column>
        <el-table-column
          label="头像">
          <template slot-scope="scope">
            <div v-if="scope.row.portrait.Valid">
              <img :src="scope.row.portrait.String" class="avatarimg3">
            </div>
            <div v-else>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone.String"
          label="联系方式">
        </el-table-column>
        <el-table-column
          prop="addtime.String"
          label="添加时间">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="班级选择" :visible.sync="vis_sel_class">
      <el-table
        fit
        :data="data_class"
        highlight-current-row
        @current-change="sel_class_change"
        ref="multipleTable">
        <el-table-column
          prop="id.Int64"
          label="班级编号">
        </el-table-column>
        <el-table-column
          prop="cname.String"
          width="180px"
          label="班级名">
        </el-table-column>
        <el-table-column
          prop="ctype"
          label="类别ID">
        </el-table-column>
        <el-table-column
          prop="teacherlist.String"
          label="讲师ID列表">
        </el-table-column>
        <el-table-column
          prop="courselist.String"
          label="课程ID列表">
        </el-table-column>
        <el-table-column
          prop="agearea.String"
          label="适合年龄段">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="课程选择" :visible.sync="vis_sel_course">
      <el-table
        fit
        :data="data_course"
        highlight-current-row
        @current-change="sel_course_change"
        ref="multipleTable">
        <el-table-column
          prop="id.Int64"
          label="课程编号">
        </el-table-column>
        <el-table-column
          prop="ctitle.String"
          width="180px"
          label="课程名称">
        </el-table-column>
        <el-table-column
          prop="csubtitle.String"
          label="课程子标题">
        </el-table-column>
        <el-table-column
          prop="addtime.String"
          label="添加时间">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="用户选择" :visible.sync="vis_sel_member">
      <el-table
        stripe
        :data="data_member"
        highlight-current-row
        @current-change="sel_member_change"
        ref="multipleTable">
        <el-table-column
          prop="usernick.String"
          width = "200px"
          label="会员昵称">
        </el-table-column>
        <el-table-column
          label="头像">
          <template slot-scope="scope">
            <div v-if="scope.row.userimg.Valid && scope.row.userimg.String !== ''">
              <img :src="scope.row.userimg.String" class="avatarimg">
            </div>
            <div v-else>
              {{scope.row.userimg.String}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone.String"
          label="电话号码">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'TeachSchedule',
  beforeCreate: function () {
    that = this
    console.log('开始创建')
  },
  data () {
    return {
      qdtab: 'readyyy',
      pkdate: '',
      ed_user_info: '',
      ed_user_list: [],
      data_jsjt: [],
      tscheduledate: '',
      ts_start: '',
      ts_end: '',
      ed_ts_des: '',
      ed_ts_teacher: '',
      ed_ts_class: '',
      ed_ts_course: '',
      ed_ma_member: '',
      vis_sel_teacher: false,
      vis_sel_class: false,
      vis_sel_course: false,
      vis_sel_member: false,
      data_teacher: [],
      data_class: [],
      data_course: [],
      data_member: [],
      sel_teacher: '',
      sel_teacher1: '',
      sel_class: '',
      sel_course: '',
      sel_member: '',
      ed_course_teacher: '',
      ed_course_teacherlist: [],
      data_pk: []
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      that.$options.methods.querymember()
    }
  },
  methods: {
    query_pk () {
      var qstr = 'cusid =' + that.khid
      if (that.ed_user_info !== null && that.ed_user_info !== '') {
        qstr = qstr + " and userphone ='" + that.ed_user_info + "'"
      }
      if (this.pkdate !== null && this.pkdate !== '') {
        qstr = qstr + " and plandate >= '" + this.pkdate[0] + "' and plandate<='" + this.pkdate[1] + "'"
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qbch',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_pk = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_jsjt () {
      var qstr = 'cusid =' + that.khid
      if (that.ed_user_info !== null && that.ed_user_info !== '') {
        qstr = qstr + " and phone ='" + that.ed_user_info + "'"
      }
      if (this.pkdate !== null && this.pkdate !== '') {
        qstr = qstr + " and plandate >= '" + this.pkdate[0] + "' and plandate<='" + this.pkdate[1] + "'"
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qbth',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取班级数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_jsjt = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    del_pk: function (index, data) {
      console.log(data[index])
      var curselectdata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/dbch',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    del_jsjt: function (index, data) {
      var curselectdata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/dbth',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryteacher () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/teacher/qti',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sortinfo: {String: ' order by addtime desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取讲师数据')
            localStorage.setItem('teacherinfo', res.data.data)
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_teacher = JSON.parse(res.data.data)
            that.ed_course_teacherlist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryclass () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/qbci',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取班级数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_class = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querycourse () {
      var qstr = 'cusid =' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qci',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by addtime desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取产品数据')
            localStorage.setItem('courseinfo', res.data.data)
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_course = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querymember () {
      var qstr = ' usernick is not null '
      that.$http({
        url: 'https://api.sqnetsoft.cn/member/gbmu',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.data_member = JSON.parse(res.data.data)
            that.ed_user_list = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    sel_teacher_change (val) {
      this.sel_teacher = val
      console.log(this.sel_teacher)
      this.vis_sel_teacher = false
      this.ed_ts_teacher = this.sel_teacher.name.String
    },
    sel_class_change (val) {
      this.sel_class = val
      console.log(this.sel_class)
      this.vis_sel_class = false
      this.ed_ts_class = this.sel_class.cname.String
    },
    sel_course_change (val) {
      this.sel_course = val
      console.log(this.sel_course)
      this.vis_sel_course = false
      this.ed_ts_course = this.sel_course.ctitle.String
    },
    sel_member_change (val) {
      this.sel_member = val
      console.log(this.sel_member)
      this.vis_sel_member = false
      this.ed_ma_member = this.sel_member.phone.String
    },
    ev_sel_teacher () {
      this.vis_sel_teacher = true
      that.$options.methods.queryteacher()
    },
    ev_sel_class () {
      this.vis_sel_class = true
      that.$options.methods.queryclass()
    },
    ev_sel_course () {
      this.vis_sel_course = true
      that.$options.methods.querycourse()
    },
    ev_sel_user () {
      this.vis_sel_member = true
      that.$options.methods.querymember()
    },
    save_vm () {
      console.log(this.tscheduledate)
      var tmpdata = new Date(this.tscheduledate)
      var week = tmpdata.getDay()
      console.log(week)
      console.log(this.ts_start)
      console.log(this.ts_end)
      console.log(this.ed_ts_teacher)
      console.log(this.ed_ts_class)
      console.log(this.ed_ts_course)
      var adddata = {
        userphone: {String: this.ed_ma_member, Valid: true},
        plandate: {String: this.tscheduledate, Valid: true},
        weekid: parseInt(week),
        weektime: {String: this.ts_start + '-' + this.ts_end, Valid: true},
        teacherid: parseInt(this.sel_teacher.id.Int64),
        classid: parseInt(this.sel_class.id.Int64),
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/aaubch',
        method: 'post',
        data: adddata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '请假完毕!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    save_jsqj () {
      console.log(this.tscheduledate)
      var tmpdata = new Date(this.tscheduledate)
      var week = tmpdata.getDay()
      console.log(week)
      console.log(this.ts_start)
      console.log(this.ts_end)
      var adddata = {
        teacherid: parseInt(this.sel_teacher.id.Int64),
        plandate: {String: this.tscheduledate, Valid: true},
        weekid: parseInt(week),
        weektime: {String: this.ts_start + '-' + this.ts_end, Valid: true},
        context: {String: this.ed_ts_des, Valid: true},
        addtime: {String: getNowFormatDate(), Valid: true},
        cusid: parseInt(this.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/aaubth',
        method: 'post',
        data: adddata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '请假完毕!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
function getNowFormatDate () {
  var date = new Date()
  var seperator1 = '-'
  var seperator2 = ':'
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var hours = date.getHours()
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }
  var minutes = date.getMinutes()
  if (minutes >= 0 && minutes <= 9) {
    minutes = '0' + minutes
  }
  var seconds = date.getSeconds()
  if (seconds >= 0 && seconds <= 9) {
    seconds = '0' + seconds
  }
  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + hours + seperator2 + minutes + seperator2 + seconds
  return currentdate
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/course/VacationMana.vue